<nb-layout>
	<nb-layout-column class="login-view info-page" scroll="false">
		<div class="server-down-content">
			<div class="logo app-hide-on-keyboard-open">
				<img [src]="noInternetLogo" />
			</div>

			<div class="info-massage">
				<h3 class="mt-4">{{ 'GAUZY_MAINTENANCE' | translate }}</h3>
			</div>
		</div>
	</nb-layout-column>
</nb-layout>
